module.exports = __webpack_public_path__ + "img/tik_logo.caa02254.png";